import coleaze_info from "./coleaze/index"
export default coleaze_info